import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-main',
  templateUrl: './main.component.html',
})
export class MainComponent {}
